import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * SectionTitle Props
 */
export default class Props extends Mixins() {
    /**
     * Class
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Color of the link and lines
     */
    @Prop({ default: 'primary' }) color!: string;

    /**
     * Title
     */
    @Prop() title!: string;

    /**
     * Subtitle
     */
    @Prop() subtitle!: string;

    /**
     * link
     */
    @Prop() link!: string | object;

    /**
     * Link Text
     */
    @Prop() linkText!: string;

    /**
     * Show Icon in link
     */
    @Prop({ type: Boolean }) hasIcon!: boolean;

    /**
     * Link Icon
     */
    @Prop({ type: String }) linkIcon!: string;

    /**
     * Add line to the Title
     */
    @Prop({ type: Boolean }) titleLine!: boolean;

    /**
     * Set justify content center
     */
    @Prop({ type: Boolean }) center!: boolean;

    /**
     * Set scroll for button
     * ScrollTo package
     */
    @Prop({ type: Boolean }) scrollButton!: boolean;

    /**
     * Half line
     */
    @Prop({ type: Boolean }) halfLine!: boolean;
}
